// Shared between MarketInsightsView's comp cards and PropertyHeader's subject
// vitals so the same lot size/FAR math can't quote different numbers for the
// same "apples to apples" comparison.

const SQFT_PER_ACRE = 43560;

export const computeFarPct = (property: { sqFt?: number; lotSizeSqFt?: number }): number | undefined =>
  property.sqFt && property.lotSizeSqFt ? (property.sqFt / property.lotSizeSqFt) * 100 : undefined;

/** "11,699 sqft (0.27 acres)" — falls back to plain sqft if acres is negligible/zero. */
export const formatLotSize = (lotSizeSqFt?: number): string => {
  if (!lotSizeSqFt) return 'Not available';
  const acres = lotSizeSqFt / SQFT_PER_ACRE;
  return `${lotSizeSqFt.toLocaleString()} sqft (${acres.toFixed(2)} acres)`;
};
